let prefix = '/api/sap/projects';
function getProjects() {
    return window.axios.get(prefix+'/index')
}
export default {
    getProjects
}